import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProcessSection from './components/ProcessSection';
import DocumentsSection from './components/DocumentsSection';
import PricingSection from './components/PricingSection';
import RegistrationSection from './components/RegistrationSection';
import DebtSection from './components/DebtSection';
import CTASection from './components/CTASection';
import { SEO } from '../../utils/seo';

export default function BuyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: '会社買収サービス',
    description: '休眠会社から許認可付き法人まで、豊富な案件からお選びいただけます。買収の流れ、必要書類、料金体系など詳しくサポートします。',
    provider: {
      '@type': 'Organization',
      name: '株式会社G11'
    },
    areaServed: 'JP',
    serviceType: '会社買収仲介'
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="会社を買いたい方へ | 会社買収・法人購入サービス | 株式会社G11"
        description="休眠会社から許認可付き法人まで、豊富な案件からお選びいただけます。買収の流れ、必要書類、料金体系など詳しくサポートします。スピード対応で最短での成約を実現。"
        keywords="会社買収,法人購入,休眠会社買収,企業買収,M&A,許認可付き法人"
        jsonLd={jsonLd}
      />
      <Navbar />
      <HeroSection />
      <ProcessSection />
      <DocumentsSection />
      <PricingSection />
      <RegistrationSection />
      <DebtSection />
      <CTASection />
      <Footer />
    </div>
  );
}
